import { StringUtil, ValueDisplayValue } from "@mcleod/core";
import {
    Button, ButtonVariant, Component, DesignerInterface, DialogProps, Image, PanelProps, PropType, TableColumn, TableRow,
    TableRowDisplayEvent,
    Textbox
} from "@mcleod/components";
import { RadioGroupItemEditor } from "./RadioGroupItemEditor";
import { SpecialtyEditorFactory } from "./SpecialtyEditorFactory";

export class RadioBoxItemEditor extends RadioGroupItemEditor {
    constructor(currentValueJson: string, editingDesigner: DesignerInterface, props?: Partial<PanelProps>) {
        super(currentValueJson, editingDesigner, props);
    }

    get valueCaption(): string {
        return "Value";
    }

    get valueName(): string {
        return "value";
    }

    get displayValueCaption(): string {
        return "Caption";
    }

    get displayValueName(): string {
        return "displayValue";
    }

    protected override createTable() {
        super.createTable();
        if (this.isReadOnly !== true) {
            const imageColumn = new TableColumn({
                id: "columnImage",
                index: 2,
                headingDef: {
                    caption: "Image"
                },
                cell: this.createImageCell.bind(this)
            });
            this.table.addColumn(imageColumn, false, false);
            this.table.tableHeadingRow.resetFirstLastColumnPadding();
            this.table.addRowDisplayListener((event: TableRowDisplayEvent) => {
                const row = event.getTableRow();
                const imageName = row.data.get("imageName");
                if (imageName != null) {
                    const image = row.findComponentById("imageSample") as Image;
                    if (image != null)
                        image.name = imageName;
                }
            });
        }
    }

    private createImageCell(): Component[] {
        const image = new Image({
            field: "imageName",
            id: "imageSample",
            height: 40,
            width: 40,
            rowBreak: false,
            preventCollapse: true,
            marginRight: 10
        });
        const editorFactory = new SpecialtyEditorFactory();
        const imageName = editorFactory.getButtonImage(PropType.image);
        const buttonImageSelector = new Button({
            id: "buttonImageSelector",
            imageName,
            variant: ButtonVariant.round,
            color: "subtle.light",
            rowBreak: false
        });
        buttonImageSelector.addClickListener(async () => {
            const row = TableRow.getContainingTableRow(buttonImageSelector);
            const mockTextbox = new Textbox({ text: row.data.get("imageName") });
            const specialtyEditor = editorFactory.getEditor(PropType.image, mockTextbox, null);
            await specialtyEditor.show();
            if (specialtyEditor.wasCancelled !== true) {
                const newValue = specialtyEditor.getResultValue();
                if (newValue !== undefined) {
                    row?.data.set("imageName", newValue);
                    image.name = newValue;
                }
            }
        });
        const buttonClearImage = new Button({
            id: "buttonClearImage",
            imageName: "x",
            variant: ButtonVariant.round,
            color: "subtle.light",
            tooltip: "Remove the selected image",
            rowBreak: false,
            marginLeft: 0
        });
        buttonClearImage.addClickListener(async () => {
            const row = TableRow.getContainingTableRow(buttonClearImage);
            row?.data.set("imageName", null);
            image.name = null;
        });
        return [ image, buttonImageSelector, buttonClearImage ];
    }

    protected override getItemFromTableRow(row: TableRow): ValueDisplayValue {
        const result = super.getItemFromTableRow(row);
        const imageName = row.data.get("imageName");
        result.setAddlValue("imageName", !StringUtil.isEmptyString(imageName) ? imageName : null);
        return result;
    }
}
